var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34961 15.5361H9.65039C11.1611 15.5361 11.9678 14.7158 11.9678 13.1982V7.16211H6.7041C5.86328 7.16211 5.45312 6.74512 5.45312 5.91113V0.606445H2.34961C0.838867 0.606445 0.0322266 1.41992 0.0322266 2.9375V13.1982C0.0322266 14.7227 0.838867 15.5361 2.34961 15.5361ZM6.92285 6.10254H11.8994C11.8652 5.77441 11.6123 5.45996 11.2363 5.07715L7.53125 1.32422C7.16895 0.955078 6.84082 0.702148 6.5127 0.667969V5.69922C6.5127 5.97266 6.64941 6.10254 6.92285 6.10254ZM3.36133 10.2246C3.05371 10.2246 2.83496 9.99902 2.83496 9.70508C2.83496 9.41797 3.05371 9.19922 3.36133 9.19922H8.65234C8.95312 9.19922 9.17871 9.41797 9.17871 9.70508C9.17871 9.99902 8.95312 10.2246 8.65234 10.2246H3.36133ZM3.36133 12.7607C3.05371 12.7607 2.83496 12.542 2.83496 12.2549C2.83496 11.9609 3.05371 11.7354 3.36133 11.7354H8.65234C8.95312 11.7354 9.17871 11.9609 9.17871 12.2549C9.17871 12.542 8.95312 12.7607 8.65234 12.7607H3.36133Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.2af3f671.svg";
export { ForwardRef as ReactComponent };